import { ButtonHTMLAttributes, ReactNode } from 'react';

interface GhostButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  fullWidth?: boolean;
}

export function GhostButton({ children, fullWidth = true, className = '', ...props }: GhostButtonProps) {
  return (
    <button
      className={`
        ${fullWidth ? 'w-full' : ''} py-4 px-6 rounded-lg
        bg-transparent text-[var(--color-text)]
        font-display text-sm font-medium uppercase tracking-[0.15em]
        border border-[var(--color-border)]
        active:scale-[0.97] transition-all duration-100
        cursor-pointer
        hover:border-[var(--color-volt)] hover:text-[var(--color-volt)]
        disabled:opacity-50 disabled:cursor-not-allowed
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
}
